import { VideoEmailEmbedSize } from '@core/api/types/api_video';
import { useContextTranslation } from '@core/i18n';
import { EmbedSizeImage, EmbedSizeRadioButton, EmbedSizeRadioButtonLabel, EmbedSizeRadioButtonWrapper, EmbedSizeSection, } from './EmailEmbedSizeSection.styles';
const SMALL_BUTTON_ID = 'videoSizeRadioButtonSmall';
const SMALL_LABEL_ID = 'videoSizeRadioButtonSmallLabel';
const BEST_FIT_BUTTON_ID = 'videoSizeRadioButtonBestFit';
const BEST_FIT_LABEL_ID = 'videoSizeRadioButtonBestFitLabel';
/**
 *
 */
export const EmailEmbedSizeSection = ({ onEmbedSizeChange, }) => {
    const { t } = useContextTranslation();
    return (<EmbedSizeSection>
      <EmbedSizeRadioButtonWrapper>
        <EmbedSizeRadioButton id={SMALL_BUTTON_ID} aria-labelledby={SMALL_LABEL_ID} type="radio" name="videoSize" value={VideoEmailEmbedSize.SMALL} onChange={onEmbedSizeChange}/>
        <EmbedSizeRadioButtonLabel htmlFor={SMALL_BUTTON_ID} id={SMALL_LABEL_ID}>
          <EmbedSizeImage src={require('@embed/components/common/assets/PhoneSmall.svg')} role="presentation"/>
          <span>{t('player:Small')}</span>
        </EmbedSizeRadioButtonLabel>
      </EmbedSizeRadioButtonWrapper>
      <EmbedSizeRadioButtonWrapper>
        <EmbedSizeRadioButton defaultChecked id={BEST_FIT_BUTTON_ID} aria-labelledby={BEST_FIT_LABEL_ID} type="radio" name="videoSize" value={VideoEmailEmbedSize.BEST_FIT} onChange={onEmbedSizeChange}/>
        <EmbedSizeRadioButtonLabel htmlFor={BEST_FIT_BUTTON_ID} id={BEST_FIT_LABEL_ID}>
          <EmbedSizeImage src={require('@embed/components/common/assets/PhoneBestFit.svg')} role="presentation"/>
          <span>{t('player:Best Fit')}</span>
        </EmbedSizeRadioButtonLabel>
      </EmbedSizeRadioButtonWrapper>
    </EmbedSizeSection>);
};
